"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _cat_list = require("@/api/cat_list");

var _get_cat_tags = require("@/api/get_cat_tags");

var _moment = _interopRequireDefault(require("moment"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getCatTagsList } from '@/api/cat_tags'
var _default = {
  // filters: {
  //   statusFilter(status) {
  //     const statusMap = {
  //       '已售': 'success',
  //       draft: 'gray',
  //       '未售': 'danger'
  //     }
  //     return statusMap[status]
  //   }
  // },
  data: function data() {
    return {
      filterText: '',
      catList: null,
      listLoading: true,
      catTagsList: null
    };
  },
  // watch: {
  //   filterText(val) {
  //     this.$refs.table.filter(val)
  //   }
  // },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.listLoading = true;
      (0, _get_cat_tags.getCatTags)().then(function (response) {
        var catTagsList = {};
        response.data.forEach(function (tag) {
          catTagsList[tag.id] = tag.tag;
        });
        (0, _cat_list.getList)().then(function (response) {
          var catList = response.data;
          catList.forEach(function (cat, catI) {
            var tags_name = [];
            var birthday = '';
            birthday = (0, _moment.default)(cat.birthday).format('YYYY-DD-MM');
            cat.tags.forEach(function (tag_i) {
              if (catTagsList[tag_i]) {
                tags_name.push(catTagsList[tag_i]);
              } else {
                tags_name.push('失效标签');
              }
            });
            catList[catI].tags = tags_name;
            catList[catI].birthday = birthday; // console.log(moment(cat.birthday).format("YYYY-DD-MM"))
            // console.log(new Date(new Date(cat.birthday).getTime()-8 * 60 * 60 * 1000))
          });
          catList.reverse();
          _this.catList = catList;
          _this.listLoading = false;
        });
      });
    },
    handleLink: function handleLink(id) {
      this.$router.push("/cats/details/".concat(id));
    },
    filterStatusHandler: function filterStatusHandler(value, row, column) {
      console.log(value);
      return row.status === value;
    },
    filterOnlineHandler: function filterOnlineHandler(value, row, column) {
      return row.online === value;
    },
    filterReserveHandler: function filterReserveHandler(value, row, column) {
      return row.reserve === value;
    }
  }
};
exports.default = _default;